import React, { useEffect, useState } from "react";
import { leaderboardTableData } from "../../data/order/leaderboardTableData";
import PointLeaderboardSortHeader from "./PointLeaderboardSortHeader";
import PointLeaderboardList from "./PointLeaderboardList";
import PointLeaderboardSearchSection from "./PointLeaderboardSearchSection";
import CommonPaginationSection from "../common/CommonPaginationSection";
import { useMilesPoints } from "../../hooks/useMilesPoints";
import { useSelector } from "react-redux";

function PointsLeaderboardSection() {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState(
    [...Array(10)].map((_) => leaderboardTableData()),
  );
  const { getMilesPointsLeaderboard } = useMilesPoints();
  const [ogData, setOgData] = useState([...Array(20)]);
  const { leaderboard } = useSelector((state) => state?.points);

  const loadData = () => {
    getMilesPointsLeaderboard({
      setLoading,
      filter: "",
      search: "",
      // page: pagination.page,
      // limit: pagination.perPage,
      // callback: (missions, total) => {
      //   setOgData(missions);
      //   setOrders(missions.map((reward) => missionsTableData(reward)));
      //   setPagination((prev) => ({ ...prev, total }));
      // },
      // filter,
      // sort,
    });
  };

  // console.log({ orders });

  useEffect(() => {
    setOgData(leaderboard);
    setOrders(leaderboard?.map((item) => leaderboardTableData(item)));
  }, [leaderboard?.length]);

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  return (
    <div className="flex flex-col w-full py-4">
      <PointLeaderboardSearchSection />
      {/* <PointLeaderboardSortHeader /> */}
      <PointLeaderboardList loading={loading} ogData={ogData} orders={orders} />
      <div className="w-full mt-2">
        <CommonPaginationSection
          perPage={pagination.perPage}
          total={pagination.total}
          page={pagination.page}
          callback={(pg, perPage) =>
            setPagination({ ...pagination, page: pg, perPage })
          }
        />
      </div>
    </div>
  );
}

export default PointsLeaderboardSection;
